// extracted by mini-css-extract-plugin
module.exports = {"shimmerEffect":"BrandStickers_shimmerEffect__cMMi0","shimmer":"BrandStickers_shimmer__6eOUC"};